/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrdersPageSummaryFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OrdersPageSummary } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/orders/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the order list: orders and order value in the last 30 days and the 30 before them; orders needing processing — not yet invoiced, placed in the last year and still at the status new orders start at (initialOrderStatus, so the list can be filtered to them) — and how many of those have waited two days or more; and the last 30 days' orders by source: the sales app, the storefront, or other (chiefly imports). Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrdersPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OrdersPageSummary | undefined>;
    /**
     * The figures in the metric row above the order list: orders and order value in the last 30 days and the 30 before them; orders needing processing — not yet invoiced, placed in the last year and still at the status new orders start at (initialOrderStatus, so the list can be filtered to them) — and how many of those have waited two days or more; and the last 30 days' orders by source: the sales app, the storefront, or other (chiefly imports). Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/orders/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrdersPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
